import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';

/**
 * Cliente del sync individual al CRM (ColegaStudio).
 *
 * ⚠️ PARIDAD admin↔web: mismo archivo en los dos repos porque el rebuild de
 * puntos (`correctUsersPointsBasedOnOrders`, réplica exacta) lo llama con la
 * misma línea en ambos.
 *
 * El server es quien habla con LeadConnector (el token vive en Fly); aquí solo
 * se le avisa "este cliente cambió". El server lee el doc FRESCO y decide si
 * hay algo que mandar (`crm.syncedPoints`), así que llamarlo de más es barato
 * y llamarlo dos veces seguidas converge solo.
 */

/**
 * Fire-and-forget: para colgarlo de mutaciones (puntos, edición de datos) sin
 * que el CRM pueda romper ni retrasar la operación. Nunca lanza, nunca se
 * espera.
 *
 * ⚠️ **`force` cuando lo que cambió NO son los puntos.** El server decide con
 * `needsCrmSync`, que compara `syncedPoints` y nada más: sin `force`, corregir
 * el nombre, el correo o el teléfono de alguien respondía "unchanged" y **el
 * CRM se quedaba con el dato viejo para siempre** (medido el 19-sep). Los
 * cambios de puntos no lo necesitan: ahí la comparación sí detecta la
 * diferencia, y llamar de más cuesta una escritura en el CRM por nada.
 */
export const syncCustomerToCrm = (customerId?: string, options: { force?: boolean } = {}): void => {
    if (!customerId) return;
    axiosPrivate
        .post(`/colegastudio/sync-customer/${customerId}${options.force ? '?force=true' : ''}`)
        .catch(() => undefined);
};

/**
 * Versión con respuesta, para el botón del menú: fuerza el envío aunque el
 * sistema crea que está al día, y devuelve el resultado para el toast.
 */
export const requestCrmSync = async (
    customerId: string
): Promise<{ status: 'synced' | 'unchanged' | 'skipped' | 'failed'; warning?: string }> => {
    const { data } = await axiosPrivate.post(`/colegastudio/sync-customer/${customerId}?force=true`);
    return data;
};
